import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "test-container"
}
const _hoisted_2 = {
  key: 0,
  class: "answer-input"
}
const _hoisted_3 = {
  key: 1,
  class: "expansion-display-container"
}

import SpecialButton from './components/SpecialButton/SpecialButton.vue';
import AppHeader from './components/AppHeader/AppHeader.vue';
import VictoryScreen from './components/VictoryScreen/VictoryScreen.vue';
import ExpansionDisplay from './components/ExpansionDisplay/ExpansionDisplay.vue';

import availableAcronyms from './data/acronyms.json';
import { defineComponent } from 'vue';
import { Acronym } from './types/acronym';

const shuffleAcronyms = (acronyms: Acronym[]): Acronym[] => {
  return acronyms.sort(() => Math.random() - 0.5);
};

const __default__ = defineComponent({
  data: () => ({
    acronyms: shuffleAcronyms(availableAcronyms).slice(0, 5),
    correctAnswers: [] as Boolean[],
    selectedAcronym: 0,
  }),
  name: 'AWS Acronym checker',
  components: {},
  methods: {
    incrementAcronymNumber() {
      this.selectedAcronym++;
    },
    clearGame() {
      this.acronyms = shuffleAcronyms(availableAcronyms).slice(0, 5);
      this.correctAnswers = [] as Boolean[];
      this.selectedAcronym = 0;
    },
    checkAnswer() {
      if (this.correctAnswers[this.selectedAcronym] === undefined) {
        const answerElement: any = this.$refs.answer;
        const lowercaseExpansions = this.acronyms[
          this.selectedAcronym
        ].expansions.map((expansion) => {
          return expansion.toLowerCase();
        });
        this.correctAnswers[this.selectedAcronym] =
          lowercaseExpansions.includes(
            answerElement.value.toLowerCase().trim(),
          );
      } else {
        this.incrementAcronymNumber();
      }
    },
  },
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.selectedAcronym < _ctx.acronyms.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(AppHeader, {
            numAcronym: _ctx.selectedAcronym + 1,
            totalAcronyms: _ctx.acronyms.length,
            curAcronym: _ctx.acronyms[_ctx.selectedAcronym].acronym
          }, null, 8, ["numAcronym", "totalAcronyms", "curAcronym"]),
          (_ctx.correctAnswers[_ctx.selectedAcronym] === undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("textarea", {
                  ref: "answer",
                  onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.checkAnswer && _ctx.checkAnswer(...args)), ["enter"]))
                }, null, 544),
                _createVNode(SpecialButton, { onClick: _ctx.checkAnswer }, {
                  default: _withCtx(() => [
                    _createTextVNode("Check answer")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.correctAnswers[_ctx.selectedAcronym] !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(ExpansionDisplay, {
                  isAnswerCorrect: _ctx.correctAnswers[_ctx.selectedAcronym] === true,
                  definition: _ctx.acronyms[_ctx.selectedAcronym].definition,
                  expansion: _ctx.acronyms[_ctx.selectedAcronym].expansions[0]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.correctAnswers[_ctx.selectedAcronym] === true
            ? 'You got it right 🎉'
            : 'You got it wrong 😭'), 1)
                  ]),
                  _: 1
                }, 8, ["isAnswerCorrect", "definition", "expansion"]),
                _createVNode(SpecialButton, { onClick: _ctx.checkAnswer }, {
                  default: _withCtx(() => [
                    _createTextVNode("Next acronym")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedAcronym === _ctx.acronyms.length)
      ? (_openBlock(), _createBlock(VictoryScreen, {
          key: 1,
          numCorrectAnswers: 
      _ctx.correctAnswers.filter((answer) => answer === true).length
    ,
          totalAcronyms: _ctx.acronyms.length,
          onClearGame: _ctx.clearGame
        }, null, 8, ["numCorrectAnswers", "totalAcronyms", "onClearGame"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})